import { Injectable, inject } from '@angular/core';
import { MethodApi } from '../../api/api-request';
import { Event, AlertProcess, Constants } from '@co-assist/library';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { IExternalProcessAction } from '@co-assist/library/lib/model/alertProcess.model';

@Injectable({
    providedIn: 'root'
})
export class ProcessService {
    private api = inject(MethodApi);


    addProcess(event: Event.User.AddProcessEvent): Observable<AlertProcess> {
        return this.api.postUserRequest('addProcess', event);
    }
    updateProcess(event: Event.User.UpdateProcessEvent): Observable<AlertProcess> {
        return this.api.postUserRequest('updateProcess', event);
    }
    deleteProcess(event: Event.User.DeleteProcessEvent): Observable<void> {
        return this.api.postUserRequest('deleteProcess', event);
    }
    getProcesses(event: Event.User.GetProcessesEvent): Observable<Array<AlertProcess>> {
        return this.api.postUserRequest('getProcesses', event);
    }

    retrieveProcesses(userID: string, groupID: string): Observable<Array<AlertProcess>> {
        return forkJoin([
            userID ? this.getProcesses({ id: userID }) : of([]),
            groupID ? this.getProcesses({ id: groupID }) : of([])
        ]).pipe(
            map(processes => {
                return processes[0].concat(processes[1]);
            })
        );
    }

    getActionIcon(action: Constants.Alert.ProcessActionType) {
        switch (action) {
            case Constants.Alert.ProcessActionType.PUBLIC_CALL:
                return "phone";
            case Constants.Alert.ProcessActionType.PRIVATE_CALL:
                return "dialer_sip";
            case Constants.Alert.ProcessActionType.SMS:
                return "sms";
            case Constants.Alert.ProcessActionType.EMAIL:
                return "email";
            case Constants.Alert.ProcessActionType.WHATSAPP:
                return "mark_chat_read";
            case Constants.Alert.ProcessActionType.PUSH_NOTIFICATION:
                return "smartphone";
            case Constants.Alert.ProcessActionType.BREAK:
                return "snooze";
            case Constants.Alert.ProcessActionType.WEBHOOK:
                return "http";
            case Constants.Alert.ProcessActionType.EXTERNAL_PROCESS:
                return "link"
            case Constants.Alert.ProcessActionType.ESPA:
                return "cable";
            default:
                console.error(`unknown action type : ${action}`);
        }
        return "perm_phone_msg";
    }

    isSlaveCalled(process: AlertProcess, processes: AlertProcess[]) {
        return process.slave && processes.flatMap(a => a.specificActionData).filter(s => s.actionType === Constants.Alert.ProcessActionType.EXTERNAL_PROCESS).some(a => (a as IExternalProcessAction).processID === process.processID);
    }

    /** return master processes that call the given slave process */
    getMasterCalls(process: AlertProcess, processes: AlertProcess[]): AlertProcess[] {
        return processes.filter(p => !p.slave)
            .filter(p => p.specificActionData.some(p => p.actionType === Constants.Alert.ProcessActionType.EXTERNAL_PROCESS && (p as IExternalProcessAction).processID === process.processID));

    }


}
